export const styles = (theme) => ({
    container: {
        padding: '1.5rem',
        display: 'flex',
        flexDirection: 'column',
        gap: '1rem',
    },
    buttonsContainer: {
        display: 'flex',
        justifyContent: 'flex-end',
        padding: '1rem 0',
    },
    toggleContainer: {
        display: 'flex',
        padding: '0 1rem 1rem',
        marginTop: '-1rem',
        marginBottom: '1rem',
    },
});
